import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import PPIService from "../../services/PPIService";

const TransactionLimit = ({ cardDetails, fetchCardDetails }) => {
  const [loading, setLoading] = useState();
  const [ecommEnabled, setEcommEnabled] = useState();
  const [limit, setLimit] = useState();

  useEffect(() => {
    if (cardDetails) {
      setLimit(cardDetails.ecomm_redeem_transaction_limit);

      if (cardDetails.is_ecomm_transaction_enabled === 1) {
        setEcommEnabled(true);
      } else {
        setEcommEnabled(false);
        setLimit(0);
      }
    }
  }, [cardDetails]);

  const cardLimitUpdateHandler = async () => {
    setLoading(true);
    try {
      const result = await PPIService.cardLimitUpdate(
        ecommEnabled ? "YES" : "NO",
        limit
      );

      if (!result.success) {
        Swal.fire(
          "Oops!",
          result.message || "Failed to update status",
          "error"
        );
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        await fetchCardDetails();
        Swal.fire("Success!", responseData.message, "success");
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Request Failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-3 rounded bg-light">
      {/* Top row: Label + Toggle aligned to right */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <label className="mb-0 fw-bold">E-comm Transaction</label>
        <div
          className="form-check form-switch"
          style={{ transform: "scale(1.3)" }}
        >
          <input
            className="form-check-input"
            type="checkbox"
            id="ecommSwitch"
            checked={ecommEnabled}
            onChange={() => setEcommEnabled(!ecommEnabled)}
          />
        </div>
      </div>

      {/* Limit input row */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <label className="fw-bold mb-0">Set Limit (INR)</label>
        <input
          type="text"
          className="form-control text-end bg-dark text-white"
          style={{ width: "100px", fontWeight: "bold" }}
          value={limit}
          readOnly
        />
      </div>

      {/* Range slider */}
      <input
        type="range"
        className="form-range"
        min="1"
        max="10000"
        value={limit}
        onChange={(e) => {
          setLimit(parseInt(e.target.value));
        }}
      />

      {/* Min and Max labels */}
      <div className="d-flex justify-content-between text-muted small mb-3">
        <span>(Min) 1</span>
        <span>(Max) 10000</span>
      </div>

      {/* Submit button */}
      <button
        className="btn btn-primary btn-md w-100"
        onClick={cardLimitUpdateHandler}
        disabled={loading}
      >
        {loading ? "Updating..." : "Update"}
      </button>
    </div>
  );
};

export default TransactionLimit;
